/* eslint-disable max-len */
import React from 'react';
import { connect } from 'react-redux';
import { Toast } from '@leverege/ui-elements';
import PropTypes from 'prop-types';
import { Toolbar, OkayCancelEditor, TitleBar, ModelEditorFactory } from '@leverege/ui-plugin';
import { UserSettings } from '@leverege/ui-redux';
import I18N from '@leverege/i18n';
import S from './UserSettingsModelEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tIcon
} = I18N.ns('molten.views.userSettings.UserSettingsModelEditor');
class UserSettingsModelEditor extends React.Component {
  static propTypes = {
    editor: PropTypes.elementType.isRequired,
    editorProps: PropTypes.object,
    settingsPath: PropTypes.string.isRequired,
    versionsPath: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    okayLabel: PropTypes.string,
    cancelLabel: PropTypes.string,
    closeOnSave: PropTypes.bool,
    titleIcon: PropTypes.string,
    simple: PropTypes.bool,
    titleVariant: PropTypes.string,
    handleSave: PropTypes.bool,
    onSave: PropTypes.func,
    onClose: PropTypes.func,
    variant: PropTypes.string,
    applyOnChange: PropTypes.bool
  };
  static defaultProps = {
    get okayLabel() {
      return t('okayLabel');
    },
    get cancelLabel() {
      return t('cancelLabel');
    },
    closeOnSave: true,
    get titleIcon() {
      return tIcon('titleIcon', 'fa fa-cog fa-fw');
    },
    titleVariant: 'dialogTitle',
    simple: false,
    handleSave: true,
    onSave: () => {},
    onClose: () => {},
    variant: null,
    editorProps: {},
    applyOnChange: false,
    get title() {
      return t('title');
    }
  };

  // when you actually hit save in the modal
  // TODO: eventData and shit
  onSave = async evt => {
    const {
      settingsPath,
      handleSave,
      onSave,
      closeOnSave
    } = this.props;
    if (!handleSave && onSave) {
      onSave(evt);
    } else {
      try {
        UserSettings.set(settingsPath, evt.value);
      } catch (err) {
        Toast.error([t('errorToastTitle'), t('errorToastMessage1'), t('errorToastMssage2', {
          error: err.message
        })]);
      }
      if (onSave) {
        onSave(evt);
      }
    }
    if (closeOnSave) {
      this.onClose(evt);
      if (handleSave) {
        Toast.success([t('successToastTitle'), t('successToastMessage')]);
      }
    }
  };
  getContext(editor, value, original) {
    const {
      settingsPath,
      versionsPath,
      variant,
      simple
    } = this.props;
    return {
      value,
      original,
      variant,
      settingsPath,
      versionsPath,
      onClose: this.onClose,
      editor,
      clientProps: this.props,
      simple
    };
  }

  // render the editor modal title line
  renderTitle = (value, original, variant, editor) => {
    const {
      title,
      settingsPath,
      titleIcon,
      versionsPath,
      titleVariant,
      simple,
      managePersonas = true
    } = this.props;
    // can call editor.onChange
    const context = this.getContext(editor, value, original);
    return /*#__PURE__*/_jsx("div", {
      className: S.fullWidth,
      children: /*#__PURE__*/_jsxs(TitleBar, {
        variant: titleVariant,
        title: title,
        icon: titleIcon,
        children: [/*#__PURE__*/_jsx(Toolbar, {
          variant: "actionBar",
          matchContext: {
            use: 'titleLeft',
            client: 'UserSettingsEditor',
            managePersonas,
            settingsPath,
            versionsPath
          },
          prefer: simple ? 'icon' : null,
          context: context
        }), /*#__PURE__*/_jsx(Toolbar, {
          variant: "actionBar",
          matchContext: {
            use: 'titleRight',
            client: 'UserSettingsEditor',
            managePersonas,
            settingsPath,
            versionsPath
          },
          prefer: simple ? 'icon' : null,
          context: context
        })]
      })
    });
  };
  render() {
    const {
      value,
      editor,
      editorProps,
      okayLabel,
      applyOnChange,
      cancelLabel,
      className,
      eventData
    } = this.props;
    if (!editor) {
      return null;
    }
    return /*#__PURE__*/_jsx(OkayCancelEditor, {
      className: className,
      okayLabel: okayLabel,
      cancelLabel: cancelLabel,
      applyOnChange: applyOnChange,
      title: this.renderTitle,
      editor: editor,
      editorProps: editorProps,
      value: value || {},
      eventData: eventData,
      onChange: this.onSave,
      onCancel: this.onClose
    });
  }

  // close myself
  onClose = e => {
    const {
      onClose
    } = this.props;
    if (onClose) {
      onClose(e);
    }
  };
}
export default connect((state, props) => {
  const {
    settingsPath,
    editor
  } = props;
  const value = props?.value || UserSettings.get(state, settingsPath, {
    returnPromise: false
  });
  let edit = editor;
  if (edit == null && value) {
    edit = ModelEditorFactory.get(value);
  }
  return {
    value,
    editor: edit
  };
})(UserSettingsModelEditor);